(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-mappings/assets/javascripts/channel-mappings.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-mappings/assets/javascripts/channel-mappings.js');

const deviceMap = {
  'ios-hybrid-mobile': 'ios',
  'android-hybrid-mobile': 'android',
  'web-desktop': 'desktop',
  'web-mobile': 'mobile',
  'web-tablet': 'tablet',
  default: 'desktop'
};

const contextMap = {
  WEB: 'WEB',
  VOUCHER: 'VOUCHER',
  lordagsgodis_small: 'lor_small',
  lordagsgodis_medium: 'lor_medium',
  lordagsgodis_large: 'lor_large',
  LOTTO: 'LOTTO',
  EUROJACKPOT: 'EUROJACKPOT',
  VIKINGLOTTO: 'VIKINGLOTTO',
  KENO: 'KENO',
  'ratta-lotten': 'ratta-lotten',
  MIXEN: 'MIXEN',
  default: 'WEB'
};

const getChannel = (c, d, logger) => {
  let context = contextMap[c];
  let device = deviceMap[d];

  if (!context) {
    context = contextMap.default;
    logger.warn(`Unknown context "${c}", defaulting to "${context}"`);
  }

  if (!device) {
    device = deviceMap.default;
    logger.warn(`Unknown device "${d}", defaulting to "${device}"`);
  }
  const channel = `${context},${device}`;
  logger.info(`Mapped context "${c}" and device "${d}" to channel: "${channel}"`);
  return channel;
};

let logger;
if (svs.isServer) {
  const { core: trinidad } = require('@svenskaspelab/trinidad-core');
  logger = trinidad.logger('ticket-mappings:channel-mappings');
  module.exports = {
    getChannel: (c, d) => getChannel(c, d, logger)
  };
} else {
  logger = new svs.core.log.Logger('ticket-mappings:channel-mappings');
  setGlobal('svs.ticketgames.ticketMappings.channelMappings', {
    getChannel: (c, d) => getChannel(c, d, logger)
  });
}


 })(window);